<template>
  <div class="user-management-id-auth a-5-bg">
    <p class="user-management-child-header b-1-cl a-3-bd">
      {{ $t("personal.idAuth.title") }}
    </p>
    <div v-if="kycType === '1' && appAuthOpen" class="goAppAuth a-5-bg">
      <div class="goAppAuthNote">{{ $t("personal.idAuth.step1") }}</div>
      <div class="qrCode" v-if="appDownload.app_page_url">
          <img :src="appDownload.app_page_url" alt="" >
          <div>{{ $t("personal.idAuth.appDownLoad") }}</div>
      </div>
      <div class="goAppAuthNote">{{ $t("personal.idAuth.step2") }}</div>
      <div class="exImg">
        <img src="https://saas-oss.oss-accelerate.aliyuncs.com/upload/20200805194924641.png">
      </div>
    </div>
    <div class="user-management-center a-5-bg" v-else>
      <div class="certification-process">
        <div class="div-line a-3-bd clearfix"></div>
        <div class="step-left a-5-bg">
          <p :class="this.activeP1">
            <span class="span-mark b-8-cl clearfix a-12-bg">1</span>
            {{ $t("personal.idAuth.info") }}
          </p>
        </div>
        <div class="step-center a-5-bg">
          <p :class="this.activeP2">
            <span class="span-mark b-8-cl clearfix" :class="this.activeS2"
              >2</span
            >
            {{ $t("personal.idAuth.uploadDocuments") }}
          </p>
        </div>
        <div class="step-right a-5-bg">
          <p :class="this.activeP3">
            <span class="span-mark b-8-cl clearfix" :class="this.activeS3"
              >3</span
            >
            {{ $t("personal.idAuth.submitted") }}
          </p>
        </div>
      </div>
      <div class="idAuth-center clearfix">
        <div v-if="active === '1'">
          <!-- 国家或地区 -->
          <c-inputLine
            :promptText="$t('personal.kyc.areaTitle')"
            :value="kycNationality"
            :disabled="true"
            :errorHave="true"
          />
          <!-- 证件类型 -- 中国 -->
          <!-- <c-inputLine
            v-if="kycType === '1'"
            :promptText="$t('personal.kyc.type')"
            :value="$t('personal.label.idCard')"
            :disabled="true"
            :errorHave="true"
          /> -->
          <!-- 证件类型 -- 外国 -->
          <!-- v-if="kycType === '2'" -->
          <!-- 证件类型1 -->
          <c-select
            :value="certificateType1"
            :promptText="certificateType1PromptText"
            @onChanges="certificateType1Change"
            name="certificateType1"
            :errorHave="true"
            :errorFlag="certificateTypeErrorFlag"
            :options="certificateType1Options"
          />
          <c-inputLine
            name="certificateType1Value"
            v-if='certificateType1'
            :promptText="certificateType1NumPromptText"
            :value="certificateType1Value"
            :errorHave="true"
            @onchanges="certificateTypeInputChange"
          />
          <!-- 证件类型2 -->
          <c-select
            :value="certificateType2"
            :promptText="certificateType2PromptText"
            @onChanges="certificateType2Change"
            name="certificateType2"
            :errorHave="true"
            :errorFlag="certificateTypeErrorFlag"
            :options="certificateType2Options"
          />
          <c-inputLine
            name="certificateType2Value"
            v-if='certificateType2'
            :promptText="certificateType2NumPromptText"
            :value="certificateType2Value"
            :errorHave="true"
            @onchanges="certificateTypeInputChange"
          />

          <!-- 中国 - 姓名 -->
          <!-- <c-inputLine
            v-if="kycType === '1'"
            maxLength="50"
            name="name"
            inputType="text"
            :promptText="promptText2"
            :errorHave="true"
            marginTop="0px"
            :value="checkValue2"
            @onchanges="inputChanges"
          /> -->
          <!-- 外国 - 名 -->
          <c-inputLine
            maxLength="50"
            name="kycName"
            :promptText="name"
            :errorHave="true"
            :value="kycName"
            @onchanges="inputChanges"
          />
          <!-- 外国 - 姓 -->
          <c-inputLine
            maxLength="50"
            name="kycFamilyName"
            :promptText="fName"
            :errorHave="true"
            :value="kycFamilyName"
            @onchanges="inputChanges"
          />
          <c-inputLine
            name="address"
            maxLength="35"
            inputType="text"
            :promptText="promptText1"
            :errorHave="true"
            :errorText="errorText1"
            :errorFlag="checkErrorFlag1"
            marginTop="0px"
            :value="address"
            @onchanges="certificateTypeInputChange"
          />
          <div class="upload-text clearfix">
            <!-- 1、认证信息一经验证不可修改，请务必如实填写 -->
            <p>
              <span v-if="$t('personal.kyc.text2').trim()">1、</span>
              {{ $t("personal.kyc.text1") }}
            </p>
            <!-- 2、被认证的实名信息不能重复认证 -->
            <p v-if="$t('personal.kyc.text2').trim().length">
              2、{{ $t("personal.kyc.text2") }}
            </p>
          </div>
          <c-button
            type="solid"
            :big="true"
            :disabled="kycStep1Disabled"
            marginTop="18px"
            height="40px"
            width="100%"
            @click="btnLink(1)"
            >{{ $t("personal.idAuth.next") }}
            </c-button>
        </div>
        <div v-if="active === '2'">
          <div>
            <!-- 证件1 正面 -->
            <div class="upload1 clearfix">
              <div class="upload1-left a-4-bg a-2-bd clearfix">
                <div v-if="firstPhotoLoading">
                  <c-loading
                    size="34"
                    className="common-button-loading a-12-bd"
                  />
                  <p class="b-4-cl loading-text">
                    {{ $t("personal.prompt.uploading") }}
                  </p>
                </div>
                <div class="loading-Img" v-else>
                  <svg class="icon icon-24" aria-hidden="true">
                    <use xlink:href="#icon-e_9"></use>
                  </svg>
                  <p v-if="kycType === '1'" class="b-4-cl">
                    {{
                      firstPhoto
                        ? $t("personal.idAuth.uploadIdCardPositiveAgain")
                        : $t("personal.idAuth.uploadIdCardPositive")
                    }}
                  </p>
                  <p v-else class="b-4-cl">
                    <!-- {{
                      firstPhoto
                        ? $t("personal.idAuth.uploadPassportPositiveAgain")
                        : $t("personal.idAuth.uploadPassportPositive")
                    }} -->
                    {{
                      firstPhoto
                        ? $t("personal.idAuth.uploadIdCardPositiveAgain")
                        : $t("personal.idAuth.uploadIdCardPositive")
                    }}
                  </p>
                </div>
                <div class="loading-mc b-2-bg" v-if="firstPhotoImg !== ''">
                  <img :src="firstPhotoImg" class="loading-img" />
                  <div class="b-2-bg"></div>
                </div>
                <c-oldUploadFile
                  className="upload_file"
                  maxSize="8"
                  name="firstPhoto"
                  url="common/upload_img"
                  :isOpenUploadImg="isOpenUploadImg"
                  :expand="[]"
                  imageType="1"
                  @tellMessage="onChangeFileFun"
                  @uploadFinish="uploadFinish"
                >
                </c-oldUploadFile>
              </div>
              <div class="upload1-right clearfix"
                :style="positive"></div>
              <!-- <div v-else class="upload1-right clearfix" :style="huangmao"></div> -->
            </div>
            <!-- 证件1 反面 -->
            <div class="upload2 clearfix">
              <div class="upload2-left a-4-bg a-2-bd clearfix">
                <div v-if="secondPhotoLoading">
                  <c-loading
                    size="34"
                    className="common-button-loading a-12-bd"
                  />
                  <p class="b-4-cl loading-text">
                    {{ $t("personal.prompt.uploading") }}
                  </p>
                </div>
                <div class="loading-Img" v-else>
                  <svg class="icon icon-24" aria-hidden="true">
                    <use xlink:href="#icon-e_9"></use>
                  </svg>
                  <p v-if="kycType === '1'" class="b-4-cl">
                    {{
                      secondPhoto
                        ? $t("personal.idAuth.uploadIdCardBackAgain")
                        : $t("personal.idAuth.uploadIdCardBack")
                    }}
                  </p>
                  <p v-else class="b-4-cl">
                    <!-- {{
                      secondPhoto
                        ? $t("personal.idAuth.uploadPassportBackAgain")
                        : $t("personal.idAuth.uploadPassportBack")
                    }} -->
                    {{
                      secondPhoto
                        ? $t("personal.idAuth.uploadIdCardBackAgain")
                        : $t("personal.idAuth.uploadIdCardBack")
                    }}
                  </p>
                </div>
                <div class="loading-mc b-2-bg" v-if="secondPhotoImg !== ''">
                  <img :src="secondPhotoImg" class="loading-img" />
                  <div class="b-2-bg"></div>
                </div>
                <c-oldUploadFile
                  className="upload_file"
                  maxSize="8"
                  name="secondPhoto"
                  url="common/upload_img"
                  :isOpenUploadImg="isOpenUploadImg"
                  :expand="[]"
                  imageType="1"
                  @tellMessage="onChangeFileFun"
                  @uploadFinish="uploadFinish"
                >
                </c-oldUploadFile>
              </div>
              <div class="upload2-right clearfix"
              :style="reverse"></div>
              <!-- <div v-else class="upload2-right clearfix" :style="bg1"></div> -->
            </div>
            <!-- 证件2 正面 -->
            <div class="upload1 upload2 clearfix">
              <div class="upload1-left a-4-bg a-2-bd clearfix">
                <div v-if="thirdPhotoLoading">
                  <c-loading
                    size="34"
                    className="common-button-loading a-12-bd"
                  />
                  <p class="b-4-cl loading-text">
                    {{ $t("personal.prompt.uploading") }}
                  </p>
                </div>
                <div class="loading-Img" v-else>
                  <svg class="icon icon-24" aria-hidden="true">
                    <use xlink:href="#icon-e_9"></use>
                  </svg>
                  <p v-if="kycType === '1'" class="b-4-cl">
                    {{
                      thirdPhoto
                        ? $t("personal.idAuth.uploadIdCardPositiveAgain")
                        : $t("personal.idAuth.uploadIdCardPositive2")
                    }}
                  </p>
                  <p v-else class="b-4-cl">
                    <!-- {{
                      thirdPhoto
                        ? $t("personal.idAuth.uploadPassportPositiveAgain")
                        : $t("personal.idAuth.uploadPassportPositive")
                    }} -->
                    {{
                      thirdPhoto
                        ? $t("personal.idAuth.uploadIdCardPositiveAgain")
                        : $t("personal.idAuth.uploadIdCardPositive2")
                    }}
                  </p>
                </div>
                <div class="loading-mc b-2-bg" v-if="thirdPhotoImg !== ''">
                  <img :src="thirdPhotoImg" class="loading-img" />
                  <div class="b-2-bg"></div>
                </div>
                <c-oldUploadFile
                  className="upload_file"
                  maxSize="8"
                  name="thirdPhoto"
                  url="common/upload_img"
                  :isOpenUploadImg="isOpenUploadImg"
                  :expand="[]"
                  imageType="1"
                  @tellMessage="onChangeFileFun"
                  @uploadFinish="uploadFinish"
                >
                </c-oldUploadFile>
              </div>
              <div class="upload1-right clearfix"
              :style="positive"></div>
              <!-- <div v-else class="upload1-right clearfix" :style="huangmao"></div> -->
            </div>
            <!-- 证件2 反面 -->
            <div class="upload2 clearfix">
              <div class="upload2-left a-4-bg a-2-bd clearfix">
                <div v-if="fourthPhotoLoading">
                  <c-loading
                    size="34"
                    className="common-button-loading a-12-bd"
                  />
                  <p class="b-4-cl loading-text">
                    {{ $t("personal.prompt.uploading") }}
                  </p>
                </div>
                <div class="loading-Img" v-else>
                  <svg class="icon icon-24" aria-hidden="true">
                    <use xlink:href="#icon-e_9"></use>
                  </svg>
                  <p v-if="kycType === '1'" class="b-4-cl">
                    {{
                      fourthPhoto
                        ? $t("personal.idAuth.uploadIdCardBackAgain2")
                        : $t("personal.idAuth.uploadIdCardBack2")
                    }}
                  </p>
                  <p v-else class="b-4-cl">
                    <!-- {{
                      fourthPhoto
                        ? $t("personal.idAuth.uploadPassportBackAgain")
                        : $t("personal.idAuth.uploadPassportBack")
                    }} -->
                    {{
                      fourthPhoto
                        ? $t("personal.idAuth.uploadIdCardBackAgain2")
                        : $t("personal.idAuth.uploadIdCardBack2")
                    }}
                  </p>
                </div>
                <div class="loading-mc b-2-bg" v-if="fourthPhotoImg !== ''">
                  <img :src="fourthPhotoImg" class="loading-img" />
                  <div class="b-2-bg"></div>
                </div>
                <c-oldUploadFile
                  className="upload_file"
                  maxSize="8"
                  name="fourthPhoto"
                  url="common/upload_img"
                  :isOpenUploadImg="isOpenUploadImg"
                  :expand="[]"
                  imageType="1"
                  @tellMessage="onChangeFileFun"
                  @uploadFinish="uploadFinish"
                >
                </c-oldUploadFile>
              </div>
              <div class="upload2-right clearfix"
              :style="reverse"></div>
              <!-- <div v-else class="upload2-right clearfix" :style="bg1"></div> -->
            </div>
            <!-- 地址 -->
            <div class="upload3 clearfix">
              <div class="upload2-left a-4-bg a-2-bd clearfix">
                <div v-if="fifthPhotoLoading">
                  <c-loading
                    size="34"
                    className="common-button-loading a-12-bd"
                  />
                  <p class="b-4-cl loading-text">
                    {{ $t("personal.prompt.uploading") }}
                  </p>
                </div>
                <div class="loading-Img" v-else>
                  <svg class="icon icon-24" aria-hidden="true">
                    <use xlink:href="#icon-e_9"></use>
                  </svg>
                  <p v-if="kycType === '1'" class="b-4-cl">
                    {{
                      fifthPhoto
                        ? $t("personal.idAuth.uploadAddress")
                        : $t("personal.idAuth.uploadAddress")
                    }}
                  </p>
                  <p v-else class="b-4-cl">
                    {{
                      fifthPhoto
                        ? $t("personal.idAuth.uploadAddress")
                        : $t("personal.idAuth.uploadAddress")
                    }}
                    <!-- {{
                      fifthPhoto
                        ? $t(
                            "personal.idAuth.uploadPassportPersonalPositivAgain"
                          )
                        : $t("personal.idAuth.uploadPassportPersonalPositiv")
                    }} -->
                  </p>
                </div>
                <div class="loading-mc" v-if="fifthPhotoImg !== ''">
                  <img :src="fifthPhotoImg" class="loading-img" />
                  <div class="b-2-bg"></div>
                </div>
                <c-oldUploadFile
                  className="upload_file"
                  maxSize="8"
                  name="fifthPhoto"
                  url="common/upload_img"
                  :isOpenUploadImg="isOpenUploadImg"
                  :expand="[]"
                  :isWaterMark="true"
                  imageType="1"
                  @tellMessage="onChangeFileFun"
                  @uploadFinish="uploadFinish"
                >
                </c-oldUploadFile>
              </div>
              <div class="upload2-right clearfix" :style="shuidiantuUrl"></div>
            </div>
            <!-- 手持照 -->
            <div class="upload3 clearfix">
              <div class="upload2-left a-4-bg a-2-bd clearfix">
                <div v-if="sixthPhotoLoading">
                  <c-loading
                    size="34"
                    className="common-button-loading a-12-bd"
                  />
                  <p class="b-4-cl loading-text">
                    {{ $t("personal.prompt.uploading") }}
                  </p>
                </div>
                <div class="loading-Img" v-else>
                  <svg class="icon icon-24" aria-hidden="true">
                    <use xlink:href="#icon-e_9"></use>
                  </svg>
                  <p v-if="kycType === '1'" class="b-4-cl">
                    {{
                      sixthPhoto
                        ? $t("personal.idAuth.uploadIdCardPersonalPositivAgain")
                        : $t("personal.idAuth.uploadIdCardPersonalPositiv")
                    }}
                  </p>
                  <p v-else class="b-4-cl">
                    {{
                      sixthPhoto
                        ? $t(
                            "personal.idAuth.uploadPassportPersonalPositivAgain"
                          )
                        : $t("personal.idAuth.uploadPassportPersonalPositiv")
                    }}
                  </p>
                </div>
                <div class="loading-mc" v-if="sixthPhotoImg !== ''">
                  <img :src="sixthPhotoImg" class="loading-img" />
                  <div class="b-2-bg"></div>
                </div>
                <c-oldUploadFile
                  className="upload_file"
                  maxSize="8"
                  name="sixthPhoto"
                  url="common/upload_img"
                  :isOpenUploadImg="isOpenUploadImg"
                  :expand="[]"
                  :isWaterMark="true"
                  imageType="1"
                  @tellMessage="onChangeFileFun"
                  @uploadFinish="uploadFinish"
                >
                </c-oldUploadFile>
              </div>
              <div class="upload2-right clearfix"
              :style="handheld"></div>
              <!-- <div v-else class="upload2-right clearfix"
              :style="huangmaoUp"></div> -->
            </div>
            <div class="upload-text clearfix">
              <p>1、{{ $t("personal.idAuth.uploadText")[0] }}</p>
              <p>2、{{ $t("personal.idAuth.uploadText")[1] }}</p>
              <p>3、{{ $t("personal.idAuth.uploadText")[2] }}</p>
              <p v-if="kycMetaText.length">4、{{ kycMetaText }}</p>
              <p v-else>4、{{ $t("personal.idAuth.uploadText")[3] }}</p>
              <p>5、{{ $t("personal.idAuth.uploadText")[4] }}</p>
              <p v-if="$t('personal.idAuth.uploadText')[5]
                && $t('personal.idAuth.uploadText')[5].trim()">
                6、{{ $t("personal.idAuth.uploadText")[5] }}
              </p>
            </div>
            <c-button
              type="solid"
              :big="true"
              className=""
              paddingW="0px"
              :loading="loading"
              :disabled="disabled2"
              marginTop="18px"
              height="40px"
              width="100%"
              @click="btnLink(2)"
              >{{ $t("personal.tool.submit") }}</c-button
            >
          </div>
        </div>
        <div v-if="active === '3'">
          <div class="audit-information">
            <svg class="icon icon-50" aria-hidden="true">
              <use xlink:href="#icon-g_3"></use>
            </svg>
            <p>
              {{ $t("personal.idAuth.wait")[0] }} <br />{{
                $t("personal.idAuth.wait")[1]
              }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mixin from 'BlockChain-ui-privatization/PC/common-mixin/personal/IdAuth/IdAuth';
import 'BlockChain-ui-privatization/PC/common-mixin/personal/IdAuth/IdAuth.styl';

import shuiDianTu from '../../assets/images/1/shuidiantu.gif';

import huangmaoUrl from '../../assets/images/1/huangmao.png';
import huangmaoUpUrl from '../../assets/images/1/huangmaoUp.png';

export default {
  mixins: [mixin],
  mounted() {
    this.init();
  },
  data() {
    return {
      promptText1: this.$t('personal.label.promptText1'),
      shuidiantuUrl: {
        backgroundImage: `url(${shuiDianTu})`,
        backgroundSize: '100%',
      },
      huangmao: {
        backgroundImage: `url(${huangmaoUrl})`,
        backgroundSize: '100%',
      },
      huangmaoUp: {
        backgroundImage: `url(${huangmaoUpUrl})`,
        backgroundSize: '100%',
      },
    };
  },
};
</script>
